import React, { Component, Fragment } from 'react';
import _memoize from 'lodash.memoize';
import { EditorState } from 'draft-js';
import { LucideIcon as Icon, Button, Link, ResourceMembers } from '../../../../../../../../../../../ui-kit';
import { Trash2, Pencil } from 'lucide-react';
import { getUser } from '../../../../../../../../../../../common/utils';
import AddReply from '../../../../AddReply';
import '../styles/_comment-controls.scss';






















class Controls extends Component {
  handleToggleEditMode = _memoize(({ toggle }) =>
  () => {
    const { toggleEditMode } = this.props;
    toggleEditMode({ toggle });
  }
  );

  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty()
    };
  }

  handleUpdateContent = (editorState) => this.setState({ editorState });

  clearInput = () => this.setState({ editorState: EditorState.createEmpty() });

  render() {
    const {
      editMode,
      busy,
      comment,
      comment: {
        viewers = [],
        createdByUser,
        children = []
      },
      createReply,
      handleUpdate,
      handleDelete,
      canSave,
      isReadOnly,
      resourceOrganisationId,
      isResourceOwner,
      onInputFocus,
      shotId,
      sceneId
    } = this.props;

    const { editorState } = this.state;
    const { isUser } = getUser(createdByUser);

    const isDeletable = (isUser || isResourceOwner) && !isReadOnly;
    const isEditable = isUser && !isReadOnly;
    const hasControl = isDeletable || isEditable;

    return (
      <div className="comment-controls">
        <div className="comment-controls__container">
          {
          editMode ?
          null :

          <Fragment>
                  <ResourceMembers members={viewers} imageSize={20} showCount />
                  {
            hasControl &&
            <div className="comment-controls__container__controls">
                      {isEditable &&
              <Icon
                icon={Pencil}
                color="regent"
                hoverColor="darkDenim"
                size={16}
                onClick={this.handleToggleEditMode({ toggle: true })}
                wrapperClassName="flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" />}


                      {isDeletable &&
              <Icon
                icon={Trash2}
                color="regent"
                hoverColor="redApple"
                size={16}
                onClick={handleDelete}
                wrapperClassName="flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-red-50" />}


                    </div>}


                </Fragment>}


          {
          editMode ?

          <div className="comment-controls__container__edit-comment-controls">
                  <Link
              className="comment-controls__container__edit-comment-controls__cancel"
              button
              onClick={this.handleToggleEditMode({ toggle: false })}>

                    Cancel
                  </Link>
                  <Button
              className="comment-controls__container__edit-comment-controls__save"
              onClick={handleUpdate}
              type="SECONDARY"
              busy={busy}
              disabled={!canSave}>

                    Save Changes
                  </Button>
                </div> :
          null}

        </div>
        <AddReply
          visible={!children.length && !isReadOnly}
          createReply={createReply}
          comment={comment}
          onUpdateContent={this.handleUpdateContent}
          editorState={editorState}
          clearInput={this.clearInput}
          resourceOrganisationId={resourceOrganisationId}
          onInputFocus={onInputFocus}
          shotId={shotId}
          sceneId={sceneId} />

      </div>);

  }
}

export default Controls;